import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { comparisonsStates } from '../../hooks/useComparisonsHook';

const comparisonActions = mapDefaultValuesToActions(comparisonsStates);

export default reduxReducerHelper(comparisonActions, comparisonsStates);
